import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { CollectDataNodeProps, IdentityDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import { collectsData } from '../utils/data-collection-utils';
type InformationsectionProps = {
  node: IdentityDataNodeProps | CollectDataNodeProps;
};
const Informationsection = t0 => {
  const $ = _c(19);
  const {
    node
  } = t0;
  const collects = collectsData(node.data);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.personal"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp4);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp5);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp6);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const T0 = Item;
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp7);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = collects("full_address");
  let t10;
  if ($[15] !== T0 || $[16] !== t8 || $[17] !== t9) {
    t10 = <T0 label={t8} value={t9} />;
    $[15] = T0;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return <Section title={t2}><SubSection title={t3}><Item label={t4} value={collects("name")} /><Item label={t5} value={collects("dob")} /><Item label={t6} value={collects("email")} /><Item label={t7} value={collects("phone_number")} />{t10}</SubSection></Section>;
};
export default Informationsection;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.basic.title;
}
function _temp3($_1) {
  return $_1.basic.name;
}
function _temp4($_2) {
  return $_2.basic.dob;
}
function _temp5($_3) {
  return $_3.basic.email;
}
function _temp6($_4) {
  return $_4.basic.phone;
}
function _temp7($_5) {
  return $_5.basic.address;
}